<template>
  <div>
    <!-- Origin Side -->
    <div v-if="connection.originFiberID" class="objectDiv connectionDiv left" @contextmenu="openMenu($event, connection.originFiberID, 'origin')">
      <span>{{ connection.originLabel }}</span>
      <span class="fiberType" style="min-width: 40px">{{ connection.originFiberLogicalType ? connection.originFiberLogicalType : '-' }}</span>
      <div class="fiberDiv">
        <div class="connectionIndicator" :style="{ 'background-color': connection.originTubeColor }"/>
        <v-tooltip top v-if="connection.originFiberComment">
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs" class="fiberColour" :style="{ 'background-color': connection.originFiberColor }"/>
          </template>
          <span>{{ connection.originFiberComment }}</span>
        </v-tooltip>
        <div v-else class="fiberColour" :style="{ 'background-color': connection.originFiberColor }"/>
        <span>{{ connection.originIdentificators }}</span>
      </div>
    </div>
    <div v-else class="objectDiv connectionDiv" @click="openTubeForm('origin', connection.connectionId)" style="cursor: pointer;">
      <span style="font-size: x-large">+</span>
    </div>

    <div style="text-transform: capitalize;" class="connectorDiv connectionDiv">{{ connection.mode }}</div>

    <!-- Destination Side -->
    <div v-if="connection.destinationFiberID" class="objectDiv connectionDiv right" @contextmenu="openMenu($event, connection.destinationFiberID, 'destination')">
      <div class="fiberDiv">
        <span>{{ connection.destinationIdentificators }}</span>
        <v-tooltip top v-if="connection.destinationFiberComment">
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs" class="fiberColour" :style="{ 'background-color': connection.destinationFiberColor }"/>
          </template>
          <span>{{ connection.destinationFiberComment }}</span>
        </v-tooltip>
        <div v-else class="fiberColour" :style="{ 'background-color': connection.destinationFiberColor }"/>
        <div class="connectionIndicator" :style="{ 'background-color': connection.destinationTubeColor }"/>
      </div>
      <span class="fiberType" style="min-width: 40px">{{ connection.destinationFiberLogicalType ? connection.destinationFiberLogicalType : '-' }}</span>
      <span>{{ connection.destinationLabel }}</span>
    </div>
    <div v-else class="objectDiv connectionDiv" @click="openTubeForm('destination', connection.connectionId)" style="cursor: pointer;">
      <span style="font-size: x-large">+</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Connection",

  props: {
    connection: {
      type: Object
    },
  },

  methods: {
    /**
     * Emits an event to open the fiber menu
     *
     * @param {Evene} e the click event
     * @param {String} fiberId the clicked fiber id
     * @param {String} side the connection side of the clicked fiber
     */
    openMenu(e, fiberId, side) {
      e.preventDefault();
      this.$emit('open-menu', {e: e, fiberId: fiberId, side: side});
    },

    /**
     * Emits an event to open the tube form
     *
     * @param {String} connectionSide the connection side of the clicked fiber
     * @param {String} connectionId the id of the selected fiber connection
     */
    openTubeForm(connectionSide, connectionId = null) {
      this.$emit('open-tube-form',
      {
        connectionSide: connectionSide,
        connectionId: connectionId,
      });
    },
  },
}
</script>

<style scoped>
.objectDiv {
  width: 42%;
}
.connectorDiv {
  width: 14%;
}
.connectionDiv {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 30px;
  background-color: white;
  border-radius: 8px;
  font-size: 14px;
}

.connectionIndicator {
  width: 25px;
  height: 17px;
  border-radius: 8px;
  border: 1px solid rgb(66, 66, 66);
}
.fiberColour {
  height: 12px;
  width: 12px;
  border-radius: 6px;
  border: 1px solid rgb(66, 66, 66);
  margin: 0 5px;
}
.fiberDiv {
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-width: 110px;
}

.left .fiberDiv {
  justify-content: flex-start;
}
.right .fiberDiv {
  justify-content: flex-end;
}

span {
  text-overflow: ellipsis;
}

.fiberType {
  min-width: 40px;
  max-width: 110px;
  overflow: hidden;
}


@media only screen and (max-width: 1800px) {
  .fiberType {
    max-width: 85px;
  }
}

@media only screen and (max-width: 1550px) {
  .fiberType {
    max-width: 45px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/Connection.vue